document.addEventListener("DOMContentLoaded", function () {
  var calendarEl = document.getElementById("calendar");
  var cardsEl = document.getElementById("calendar-cards");
  if (!calendarEl && !cardsEl) return; // Only run on the calendar page.

  // Category -> color. Keys must match the event.category metafield values.
  // "hidden" and "Productostienda" are excluded from the feed entirely.
  var CATEGORY_COLORS = {
    "Paramahamsa Vishwananda": "#8d734a",
    "Festividad": "#002554",
    "Conocimiento": "#d65f00",
    "Yoga&Meditación": "#2ba0af",
    "Rituales": "#534369",
    "Artes Devocionales": "#718b49",
    "Retiro": "#002554"
  };
  var DEFAULT_COLOR = "#002554";
  var MONTHS_ES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

  function el(id) { return document.getElementById(id); }

  function canHover() {
    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  }

  function addOneDay(dateStr) {
    if (!dateStr) return null;
    var d = new Date(dateStr + "T12:00:00");
    if (isNaN(d.getTime())) return null;
    d.setDate(d.getDate() + 1);
    return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
  }

  function formatDateShort(dateStr) {
    if (!dateStr) return "";
    var d = new Date(dateStr + "T12:00:00");
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "numeric" });
  }

  function dateParts(dateStr) {
    if (!dateStr) return null;
    var d = new Date(dateStr + "T12:00:00");
    if (isNaN(d.getTime())) return null;
    return { day: d.getDate(), mon: MONTHS_ES[d.getMonth()] };
  }

  // Register Spanish locale (the bundled FullCalendar core ships without locales).
  if (window.FullCalendar && FullCalendar.globalLocales) {
    FullCalendar.globalLocales.push({
      code: "es",
      week: { dow: 1, doy: 4 },
      buttonText: {
        prev: "Ant.",
        next: "Sig.",
        today: "Hoy",
        month: "Mes",
        week: "Semana",
        day: "Día",
        list: "Lista"
      },
      weekText: "S",
      allDayText: "Todo el día",
      moreLinkText: "más",
      noEventsText: "No hay eventos para mostrar"
    });
  }

  // Events are rendered server-side into #calendar-events-data (see
  // templates/page.calendar.liquid). Reading from the DOM avoids a client fetch,
  // which fails behind the storefront password / in theme preview.
  function loadEvents() {
    var node = document.getElementById("calendar-events-data");
    if (!node) return [];
    try {
      return JSON.parse(node.textContent.trim()) || [];
    } catch (e) {
      console.error("Calendar: could not parse embedded events", e);
      return [];
    }
  }

  // Feed event -> FullCalendar event. FullCalendar's all-day "end" is exclusive,
  // so push it one day forward to span through the real last day.
  function toCalEvent(e) {
    var color = CATEGORY_COLORS[e.category] || DEFAULT_COLOR;
    return {
      title: e.title,
      start: e.start,
      end: addOneDay(e.end || e.start),
      backgroundColor: color,
      borderColor: color,
      textColor: "#ffffff",
      display: "block",
      extendedProps: {
        category: e.category,
        url: e.url,
        image: e.image || null,
        price: e.price || "",
        rawStart: e.start,
        rawEnd: e.end || null
      }
    };
  }

  /* ---- Hover tooltip ---- */
  var tooltip = el("calendar-tooltip");
  var hideTimer = null;
  var showTimer = null;

  function positionTooltip(anchorEl) {
    var rect = anchorEl.getBoundingClientRect();
    var tw = 280;
    var tipHeight = tooltip.offsetHeight || 320;
    var pad = 8;

    var left = rect.left + rect.width / 2 - tw / 2;
    if (left < pad) left = pad;
    if (left + tw > window.innerWidth - pad) left = window.innerWidth - pad - tw;

    var top;
    var spaceBelow = window.innerHeight - rect.bottom;
    if (spaceBelow >= tipHeight + pad) {
      top = rect.bottom + pad;
    } else {
      top = rect.top - tipHeight - pad;
      if (top < pad) top = pad;
    }

    tooltip.style.left = left + "px";
    tooltip.style.top = top + "px";
  }

  function showTooltip(fcEvent, anchorEl) {
    if (!tooltip) return;
    clearTimeout(hideTimer);
    clearTimeout(showTimer);

    showTimer = setTimeout(function () {
      var p = fcEvent.extendedProps;

      el("ec-tip-title").textContent = fcEvent.title;

      var startStr = formatDateShort(p.rawStart);
      var endStr = p.rawEnd ? formatDateShort(p.rawEnd) : "";
      el("ec-tip-dates").textContent =
        endStr && endStr !== startStr ? startStr + " — " + endStr : startStr;

      var priceEl = el("ec-tip-price");
      if (p.price) {
        priceEl.textContent = p.price;
        priceEl.style.display = "block";
      } else {
        priceEl.style.display = "none";
      }

      var img = el("ec-tip-img");
      if (p.image) {
        img.src = p.image;
        img.alt = fcEvent.title;
        img.style.display = "block";
      } else {
        img.style.display = "none";
      }

      el("ec-tip-btn").href = p.url || "#";

      positionTooltip(anchorEl);
      tooltip.classList.add("ec-tooltip-visible");
    }, 200);
  }

  function scheduleHide() {
    clearTimeout(showTimer);
    hideTimer = setTimeout(function () {
      tooltip.classList.remove("ec-tooltip-visible");
    }, 300);
  }

  if (tooltip) {
    tooltip.addEventListener("mouseenter", function () { clearTimeout(hideTimer); });
    tooltip.addEventListener("mouseleave", function () { scheduleHide(); });
  }

  /* ---- State ---- */
  var calendar;
  var allEvents = [];
  var currentFilter = "all";

  function mobileCheck() { return !(window.innerWidth >= 768); }

  // Filtered raw feed events, sorted by start date (earliest first).
  function filteredRaw() {
    var list = currentFilter === "all"
      ? allEvents
      : allEvents.filter(function (e) { return e.category === currentFilter; });
    return list.slice().sort(function (a, b) {
      return String(b.start || "").localeCompare(String(a.start || ""));
    });
  }

  function filteredEvents() {
    return filteredRaw().map(toCalEvent);
  }

  /* ---- Card view ---- */
  function buildCard(e) {
    var a = document.createElement("a");
    a.className = "ec-card";
    a.href = e.url || "#";

    var media = document.createElement("div");
    media.className = "ec-card__media";
    if (e.image) {
      var img = document.createElement("img");
      img.className = "ec-card__img";
      img.src = e.image;
      img.alt = e.title || "";
      img.loading = "lazy";
      media.appendChild(img);
    } else {
      media.classList.add("ec-card__media--empty");
    }
    var parts = dateParts(e.start);
    if (parts) {
      var badge = document.createElement("div");
      badge.className = "ec-card__badge";
      var mon = document.createElement("span");
      mon.className = "ec-card__badge-mon";
      mon.textContent = parts.mon;
      var day = document.createElement("span");
      day.className = "ec-card__badge-day";
      day.textContent = parts.day;
      badge.appendChild(mon);
      badge.appendChild(day);
      media.appendChild(badge);
    }
    a.appendChild(media);

    var body = document.createElement("div");
    body.className = "ec-card__body";

    if (e.category) {
      var cat = document.createElement("span");
      cat.className = "ec-card__cat";
      cat.textContent = e.category;
      body.appendChild(cat);
    }

    var title = document.createElement("h3");
    title.className = "ec-card__title";
    title.textContent = e.title || "";
    body.appendChild(title);

    var dates = document.createElement("div");
    dates.className = "ec-card__dates";
    var s = formatDateShort(e.start);
    var en = e.end ? formatDateShort(e.end) : "";
    dates.textContent = en && en !== s ? s + " — " + en : s;
    body.appendChild(dates);

    if (e.teacher) {
      var teacher = document.createElement("div");
      teacher.className = "ec-card__dates";
      teacher.textContent = e.teacher;
      body.appendChild(teacher);
    }

    if (e.location) {
      var location = document.createElement("div");
      location.className = "ec-card__dates";
      location.textContent = e.location;
      body.appendChild(location);
    }

    if (e.price) {
      var price = document.createElement("div");
      price.className = "ec-card__price";
      price.textContent = e.price;
      body.appendChild(price);
    }

    var btn = document.createElement("span");
    btn.className = "ec-card__btn";
    btn.textContent = "Ver evento";
    body.appendChild(btn);

    a.appendChild(body);
    return a;
  }

  function renderCards() {
    if (!cardsEl) return;
    cardsEl.innerHTML = "";
    var list = filteredRaw();
    if (!list.length) {
      var empty = document.createElement("p");
      empty.className = "ec-empty";
      empty.textContent = "No hay eventos para mostrar.";
      cardsEl.appendChild(empty);
      return;
    }
    var frag = document.createDocumentFragment();
    list.forEach(function (e) { frag.appendChild(buildCard(e)); });
    cardsEl.appendChild(frag);
  }

  /* ---- Calendar (lazy) ---- */
  function initCalendar(view) {
    calendar = new FullCalendar.Calendar(calendarEl, {
      locale: "es",
      timeZone: "Europe/Madrid",
      initialView: view || (mobileCheck() ? "listMonth" : "dayGridMonth"),
      firstDay: 1,
      height: "auto",
      weekNumbers: true,
      headerToolbar: {
        left: mobileCheck() ? "prev,next" : "prev,next today",
        center: "title",
        right: ""
      },
      events: filteredEvents(),
      displayEventTime: false,
      eventDisplay: "block",
      dayMaxEventRows: 4,
      moreLinkClick: "popover",

      eventClick: function (info) {
        info.jsEvent.preventDefault();
        var url = info.event.extendedProps.url;
        if (url) window.location.href = url;
      },

      eventMouseEnter: function (info) {
        if (!canHover()) return;
        showTooltip(info.event, info.el);
      },

      eventMouseLeave: function () {
        if (!canHover()) return;
        scheduleHide();
      },

      eventDidMount: function (info) {
        info.el.title = "";
      }
    });

    calendar.render();
  }

  /* ---- View toggle (Tarjetas / Mes / Semana / Lista) ---- */
  var viewButtons = document.querySelectorAll("[data-ec-view]");

  function setActive(view) {
    viewButtons.forEach(function (b) {
      b.classList.toggle("is-active", b.getAttribute("data-ec-view") === view);
    });
  }

  function showCards() {
    if (cardsEl) cardsEl.style.display = "";
    if (calendarEl) calendarEl.style.display = "none";
    setActive("cards");
  }

  function showCalendar(view) {
    if (cardsEl) cardsEl.style.display = "none";
    if (calendarEl) calendarEl.style.display = "";
    if (!calendar) {
      initCalendar(view);
    } else {
      calendar.changeView(view);
      calendar.updateSize();
    }
    setActive(view);
  }

  viewButtons.forEach(function (b) {
    b.addEventListener("click", function () {
      var v = b.getAttribute("data-ec-view");
      if (v === "cards") showCards();
      else showCalendar(v);
    });
  });

  /* ---- Init: default to cards ---- */
  try {
    allEvents = loadEvents();
    renderCards();
    showCards();
  } catch (err) {
    console.error("Calendar: failed to initialise", err);
    if (cardsEl) {
      cardsEl.innerHTML =
        '<div class="ec-error">No se pudieron cargar los eventos. Actualiza la página e inténtalo de nuevo.</div>';
    }
  }

  /* ---- Category filter (applies to cards + calendar) ---- */
  var filterSelect = el("calendar-category-filter");
  if (filterSelect) {
    filterSelect.addEventListener("change", function () {
      currentFilter = this.value;
      renderCards();
      if (calendar) {
        calendar.removeAllEvents();
        calendar.addEventSource(filteredEvents());
      }
    });
  }
});
